import { useMutation } from "@apollo/client";
import React from "react";
import { SetTableFromDBResponse, SetTableFromDBArgs, SET_TABLE_FROM_DB } from "../../../Services/Agrisys_GqlDataCaller/ServiceToolCalls/GQLCalls/setTableFromDB";
import { fonts, colors } from "../../../Styles";
import { NewModal, MainContentPaddingTypes } from "../../BaseComponents";
import NewButton from "../../BaseComponents/newButton";
import { LoadingSpinner } from "../../../Services/wrapper";
import { useAicoConnection } from "../aicoConnectionContext";

interface ResetTableProps {
	isModalOpen: boolean;
	closeModal: () => void;
	onSuccess: () => void;
	tableId: number
}

export default function ResetTableModal({
	isModalOpen,
	closeModal,
	onSuccess,
	tableId
}: ResetTableProps) {
	const { state: connectionState } = useAicoConnection();

	const [resetTableFetch, { data: resetTableData, loading: resetTableLoading, error: resetTableError, reset: resetState }] = useMutation<SetTableFromDBResponse, SetTableFromDBArgs>(SET_TABLE_FROM_DB, {
		fetchPolicy: "network-only"
	});

	async function handleResetTable() {
		if (!connectionState.deviceConnection) {
			return;
		}

		const result = await resetTableFetch({ variables: {...connectionState.deviceConnection, tableid: tableId},  });
		if (result.data?.controller.setTableFromDb?.success) {
			onSuccess();
		}
	}

	function handleCloseModal() {
		resetState();
		closeModal();
	}

	return (
		<NewModal
			modalState={isModalOpen}
			header={"Reset Table "}
			predefinedButtons={{
				onClose: handleCloseModal,
			}}
			overrides={{
				mainContentPadding: MainContentPaddingTypes.secondary,
			}}
			mainContent={
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: "60px",
						marginTop: "25px",
					}}
				>
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: "10px",
						}}
					>
						<p style={{ ...fonts.fontSize1, ...fonts.header, color: colors.whitePrimary }}>WARNING!</p>
						<p style={{ ...fonts.fontSize3, ...fonts.header, color: colors.whitePrimary, textAlign: "center" }}>
							This action will reset the table on the LAN Controller to be up to date with the server, <br/> 
							this action is irreversible!
						</p>
						{resetTableLoading && <LoadingSpinner />}
						{(resetTableError
							|| (resetTableData?.controller && !resetTableData.controller.setTableFromDb?.success)
						)
							&& <p style={{ ...fonts.fontSize2, ...fonts.paragraph, color: colors.systemRed, maxWidth: "500px" }}>ERROR: Failed To Reset Table</p>
						}
						{!resetTableLoading
							&& !resetTableError
							&& resetTableData?.controller.setTableFromDb?.success
							&& <p style={{ ...fonts.fontSize2, ...fonts.paragraph, color: colors.systemGreen, maxWidth: "500px" }}>Succesfully Reset Table</p>
						}
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							alignItems: "center",
							gap: "5px",
						}}
					>
						<NewButton
							content={"Reset Table"}
							onClick={handleResetTable}
							disabled={resetTableLoading}
						/>
						<NewButton
							content={"Cancel"}
							onClick={handleCloseModal}
							disabled={resetTableLoading}
						/>
					</div>
				</div>
			}
		/>
	);
}
